import { useState } from "react";
import {
  Modal,
  Form,
  Input,
  InputNumber,
  Switch,
  Segmented,
  ColorPicker,
} from "antd";
import api from "../../api";
import { useToast } from "../../components/toast";
import Editor from "../../components/editor/Editor";
import ImageField from "../../components/media/ImageField";

const BG_PRESETS = [
  { label: "Өнгөнүүд", colors: ["#f0fdf4", "#eff6ff", "#f3e8f3", "#f3eee8"] },
];

export default function AboutSectionModal({
  type,
  editing,
  onClose,
  onSuccess,
}) {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const toast = useToast();
  const isEdit = !!editing?.id;

  const handleSubmit = async (values) => {
    setSaving(true);
    const payload = { ...values, type };
    const res = isEdit
      ? await api.about_update(editing.id, payload)
      : await api.about_create(payload);

    if ([200, 201].includes(res?.status)) {
      toast("Хадгалагдлаа", "success");
      onSuccess();
      onClose();
    } else {
      toast(res?.data?.message || "Хадгалахад алдаа гарлаа", "error");
    }
    setSaving(false);
  };

  return (
    <Modal
      open
      title={isEdit ? "Засах" : "Шинээр нэмэх"}
      onCancel={onClose}
      onOk={() => form.submit()}
      okText="Хадгалах"
      cancelText="Болих"
      confirmLoading={saving}
      width={720}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          imagePosition: "RIGHT",
          order: 0,
          isActive: true,
          ...editing,
        }}
      >
        <Form.Item
          name="title"
          label="Гарчиг"
          rules={[{ required: true, message: "Гарчиг оруулна уу" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item name="description" label="Тайлбар">
          {type === "STORY" ? (
            <Editor
              preset="basic"
              minHeight={120}
              placeholder="Тайлбар бичнэ үү..."
              className="form-editor"
            />
          ) : (
            <Input.TextArea autoSize={{ minRows: 3, maxRows: 8 }} />
          )}
        </Form.Item>

        {type === "VALUE" ? (
          <Form.Item name="icon" label="Icon">
            <ImageField />
          </Form.Item>
        ) : (
          <Form.Item name="image" label="Зураг">
            <ImageField />
          </Form.Item>
        )}

        {type === "STORY" && (
          <div className="d-flex gap-4">
            <Form.Item
              name="bgColor"
              label="Фон өнгө"
              getValueFromEvent={(color) => color?.toHexString()}
            >
              <ColorPicker presets={BG_PRESETS} showText />
            </Form.Item>
            <Form.Item name="imagePosition" label="Зургийн байрлал">
              <Segmented
                options={[
                  { label: "Зүүн", value: "LEFT" },
                  { label: "Баруун", value: "RIGHT" },
                ]}
              />
            </Form.Item>
          </div>
        )}

        <div className="d-flex gap-4">
          <Form.Item name="order" label="Дараалал">
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item name="isActive" label="Идэвхтэй" valuePropName="checked">
            <Switch />
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
}
